import React, { useState, useEffect } from 'react';
import { useLang } from '../context/LanguageContext';

const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem('nro_cookie');
    if (!seen) {
      setTimeout(() => setVisible(true), 800);
    }
  }, []);

  const close = (val) => {
    localStorage.setItem('nro_cookie', val);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60] cookie-banner rounded-xl p-5 text-white shadow-2xl">
      <h4 className="font-heading text-lg gold-text">{t('cookie.title')}</h4>
      <p className="font-body text-sm text-white/80 mt-1">
        {t('cookie.body')}
      </p>
      <div className="flex flex-wrap gap-2 mt-4">
        <button
          onClick={() => close('accept')}
          className="bg-[#f5b400] hover:bg-[#ffc630] text-black font-nav text-xs px-4 py-2 rounded-md transition-colors"
        >
          {t('cookie.accept')}
        </button>
        <button
          onClick={() => close('reject')}
          className="bg-transparent border border-white/30 hover:border-white text-white font-nav text-xs px-4 py-2 rounded-md transition-colors"
        >
          {t('cookie.reject')}
        </button>
        <button
          onClick={() => close('manage')}
          className="text-white/70 hover:text-white font-nav text-xs px-2 py-2 transition-colors"
        >
          {t('cookie.manage')}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
